export default __webpack_public_path__ + "static/media/Home Page Image.ecde1d26.jpg";